const ORDER_FULFILLMENT_FIELDS = `#graphql
  fragment OrderFulfillmentFields on Order {
    successfulFulfillments(first: 100) {
      trackingInfo {
        number
        url
      }
      fulfillmentLineItems(first: 100) {
        edges {
          node {
            lineItem {
              title
              variant {
                id
                product {
                  vendor
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

const ORDER_DISCOUNT_APPLICATION_FIELDS = `#graphql
  fragment OrderDiscountApplicationFields on Order {
    discountApplications(first: 10) {
      edges {
        node {
          __typename
          ... on ManualDiscountApplication {
            title
            description
          }
          ... on AutomaticDiscountApplication {
            title
          }
          ... on DiscountCodeApplication {
            code
            applicable
          }
          value {
            ...MoneyAmountFields
            ...PricingPercentageFields
          }
        }
      }
    }
  }
`;

const ORDER_LINE_ITEM_FIELDS_TUNE = `#graphql
  fragment OrderLineItemFieldsTune on Order {
    lineItems(first: 100) {
      edges {
        node {
          title
          quantity
          currentQuantity
          discountedTotalPrice { ...MoneyFields }
          originalTotalPrice { ...MoneyFields }
          variant {
            ...VariantBaseFields
            product {
              ...ProductFieldsTune
              dropDate: metafield(namespace: "operation", key: "drop_date") { ...MetafieldFields }
              launch: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectImageFields }
              }
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference { ...MediaImageFields }
                references(first: 10) { edges { node { ...MediaImageFields } } }
              }
            }
          }
          discountAllocations {
            allocatedAmount { ...MoneyFields }
            discountApplication {
              ...ManualDiscountApplicationFields
              ...AutomaticDiscountApplicationFields
              ...DiscountCodeApplicationFields
            }
          }
        }
      }
    }
  }
`;

const ORDER_METAFIELDS_TUNE = `#graphql
  fragment OrderMetafieldsTune on Order {
    drawStatus: metafield(namespace: "custom", key: "draw_status") { ...MetafieldFields }
    featuredImage: metafield(namespace: "operation", key: "featured_image") { ...MetafieldFields }
    isOffline: metafield(namespace: "custom", key: "isoffline") { ...MetafieldFields }
    returnStatus: metafield(namespace: "custom", key: "return_status") { ...MetafieldFields }
    instagram: metafield(namespace: "custom", key: "instagram") { ...MetafieldFields }
    serialNumber: metafield(namespace: "operation", key: "serial_number") { ...MetafieldFields }
    score: metafield(namespace: "operation", key: "score") { ...MetafieldFields }
    productCode: metafield(namespace: "operation", key: "product_code") { ...MetafieldFields }
    cardInfo: metafield(namespace: "custom", key: "card_info") { ...MetafieldFields }
    isfamilysale: metafield(namespace: "operation", key: "isfamilysale") { ...MetafieldFields }
    brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") { ...MetafieldFields }
    release_date: metafield(namespace: "operation", key: "release_date") { ...MetafieldFields }
  }
`;

const CUSTOMER_ORDER_FIELDS_TUNE = `#graphql
  fragment CustomerOrderFieldsTune on Order {
    ...OrderBaseFields
    ...OrderLineItemFieldsTune
    ...OrderFulfillmentFields
    ...OrderDiscountApplicationFields
    ...OrderMetafieldsTune
  }
`;

const ORDER_LINE_ITEM_FIELDS_YESEYESEE = `#graphql
  fragment OrderLineItemFieldsYeseyesee on Order {
    lineItems(first: 100) {
      edges {
        node {
          title
          quantity
          currentQuantity
          discountedTotalPrice { ...MoneyFields }
          originalTotalPrice { ...MoneyFields }
          variant {
            ...VariantBaseFields
            product {
              ...ProductCommonFields
              dropDate: metafield(namespace: "operation", key: "drop_date") { ...MetafieldFields }
              launch: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectImageFields }
              }
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference { ...MediaImageFields }
                references(first: 10) { edges { node { ...MediaImageFields } } }
              }
            }
          }
          discountAllocations {
            allocatedAmount { ...MoneyFields }
            discountApplication {
              ...ManualDiscountApplicationFields
              ...AutomaticDiscountApplicationFields
              ...DiscountCodeApplicationFields
            }
          }
        }
      }
    }
  }
`;

const ORDER_METAFIELDS_YESEYESEE = `#graphql
  fragment OrderMetafieldsYeseyesee on Order {
    drawStatus: metafield(namespace: "custom", key: "draw_status") { ...MetafieldFields }
    featuredImage: metafield(namespace: "operation", key: "featured_image") { ...MetafieldFields }
    isOffline: metafield(namespace: "custom", key: "isoffline") { ...MetafieldFields }
    returnStatus: metafield(namespace: "return", key: "status") { ...MetafieldFields }
    instagram: metafield(namespace: "custom", key: "instagram") { ...MetafieldFields }
    serialNumber: metafield(namespace: "operation", key: "serial_number") { ...MetafieldFields }
    score: metafield(namespace: "operation", key: "score") { ...MetafieldFields }
    productCode: metafield(namespace: "operation", key: "product_code") { ...MetafieldFields }
    cardInfo: metafield(namespace: "custom", key: "card_info") { ...MetafieldFields }
    isfamilysale: metafield(namespace: "operation", key: "isfamilysale") { ...MetafieldFields }
    brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") { ...MetafieldFields }
    release_date: metafield(namespace: "operation", key: "release_date") { ...MetafieldFields }
  }
`;

const CUSTOMER_ORDER_FIELDS_YESEYESEE = `#graphql
  fragment CustomerOrderFieldsYeseyesee on Order {
    ...OrderBaseFields
    ...OrderLineItemFieldsYeseyesee
    ...OrderFulfillmentFields
    ...OrderDiscountApplicationFields
    ...OrderMetafieldsYeseyesee
  }
`;

const ORDER_LINE_ITEM_FIELDS_THISISNEVERTHAT = `#graphql
  fragment OrderLineItemFieldsThisisneverthat on Order {
    lineItems(first: 100) {
      edges {
        node {
          title
          quantity
          currentQuantity
          discountedTotalPrice { ...MoneyFields }
          originalTotalPrice { ...MoneyFields }
          variant {
            ...VariantBaseFields
            product {
              ...ProductCommonFields
              dropDate: metafield(namespace: "operation", key: "drop_date") { ...MetafieldFields }
              launch: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectImageFields }
              }
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference { ...MediaImageFields }
                references(first: 10) { edges { node { ...MediaImageFields } } }
              }
            }
          }
          discountAllocations {
            allocatedAmount { ...MoneyFields }
            discountApplication {
              ...ManualDiscountApplicationFields
              ...AutomaticDiscountApplicationFields
              ...DiscountCodeApplicationFields
            }
          }
        }
      }
    }
  }
`;

const ORDER_METAFIELDS_THISISNEVERTHAT = `#graphql
  fragment OrderMetafieldsThisisneverthat on Order {
    drawStatus: metafield(namespace: "custom", key: "draw_status") { ...MetafieldFields }
    featuredImage: metafield(namespace: "operation", key: "featured_image") { ...MetafieldFields }
    isOffline: metafield(namespace: "custom", key: "isoffline") { ...MetafieldFields }
    returnStatus: metafield(namespace: "return", key: "status") { ...MetafieldFields }
    instagram: metafield(namespace: "custom", key: "instagram") { ...MetafieldFields }
    serialNumber: metafield(namespace: "operation", key: "serial_number") { ...MetafieldFields }
    score: metafield(namespace: "operation", key: "score") { ...MetafieldFields }
    productCode: metafield(namespace: "operation", key: "product_code") { ...MetafieldFields }
    cardInfo: metafield(namespace: "custom", key: "card_info") { ...MetafieldFields }
    isfamilysale: metafield(namespace: "operation", key: "isfamilysale") { ...MetafieldFields }
    brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") { ...MetafieldFields }
    release_date: metafield(namespace: "operation", key: "release_date") { ...MetafieldFields }
  }
`;

const CUSTOMER_ORDER_FIELDS_THISISNEVERTHAT = `#graphql
  fragment CustomerOrderFieldsThisisneverthat on Order {
    ...OrderBaseFields
    ...OrderLineItemFieldsThisisneverthat
    ...OrderFulfillmentFields
    ...OrderDiscountApplicationFields
    ...OrderMetafieldsThisisneverthat
  }
`;

const ORDER_LINE_ITEM_FIELDS_KHAKIS = `#graphql
  fragment OrderLineItemFieldsKhakis on Order {
    lineItems(first: 100) {
      edges {
        node {
          title
          quantity
          currentQuantity
          discountedTotalPrice { ...MoneyFields }
          originalTotalPrice { ...MoneyFields }
          variant {
            ...VariantBaseFields
            product {
              ...ProductCommonFields
              dropDate: metafield(namespace: "operation", key: "drop_date") { ...MetafieldFields }
              launch: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectImageFields }
              }
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference { ...MediaImageFields }
                references(first: 10) { edges { node { ...MediaImageFields } } }
              }
            }
          }
          discountAllocations {
            allocatedAmount { ...MoneyFields }
            discountApplication {
              ...ManualDiscountApplicationFields
              ...AutomaticDiscountApplicationFields
              ...DiscountCodeApplicationFields
            }
          }
        }
      }
    }
  }
`;

const ORDER_METAFIELDS_KHAKIS = `#graphql
  fragment OrderMetafieldsKhakis on Order {
    drawStatus: metafield(namespace: "custom", key: "draw_status") { ...MetafieldFields }
    featuredImage: metafield(namespace: "operation", key: "featured_image") { ...MetafieldFields }
    isOffline: metafield(namespace: "custom", key: "isoffline") { ...MetafieldFields }
    returnStatus: metafield(namespace: "return", key: "status") { ...MetafieldFields }
    instagram: metafield(namespace: "custom", key: "instagram") { ...MetafieldFields }
    serialNumber: metafield(namespace: "operation", key: "serial_number") { ...MetafieldFields }
    score: metafield(namespace: "operation", key: "score") { ...MetafieldFields }
    productCode: metafield(namespace: "operation", key: "product_code") { ...MetafieldFields }
    cardInfo: metafield(namespace: "custom", key: "card_info") { ...MetafieldFields }
    isfamilysale: metafield(namespace: "operation", key: "isfamilysale") { ...MetafieldFields }
    brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") { ...MetafieldFields }
    release_date: metafield(namespace: "operation", key: "release_date") { ...MetafieldFields }
    giftingIsAccepted: metafield(namespace: "custom", key: "gifting_is_accepted") { ...MetafieldFields }
    giftingMessageTemplate: metafield(namespace: "custom", key: "gifting_message_template") { ...MetafieldFields }
    giftingToken: metafield(namespace: "custom", key: "gifting_token") { ...MetafieldFields }
    isRaffleOrder: metafield(namespace: "raffle", key: "is_raffle_order") { ...MetafieldFields }
    raffleIsOfflinePickup: metafield(namespace: "raffle", key: "isoffline") { ...MetafieldFields }
    raffleShippingMethod: metafield(namespace: "raffle", key: "shipping_method") { ...MetafieldFields }
    raffleInstagram: metafield(namespace: "raffle", key: "instagram") { ...MetafieldFields }
    raffleCustomerName: metafield(namespace: "raffle", key: "customer_name") { ...MetafieldFields }
    rafflePhone: metafield(namespace: "raffle", key: "phone") { ...MetafieldFields }
    raffleStatus: metafield(namespace: "raffle", key: "status") { ...MetafieldFields }
    raffleCardInfo: metafield(namespace: "raffle", key: "card_info") { ...MetafieldFields }
    raffleBrandPayMethodId: metafield(namespace: "raffle", key: "brandpay_method_id") { ...MetafieldFields }
  }
`;

const CUSTOMER_ORDER_FIELDS_KHAKIS = `#graphql
  fragment CustomerOrderFieldsKhakis on Order {
    ...OrderBaseFields
    ...OrderLineItemFieldsKhakis
    ...OrderFulfillmentFields
    ...OrderDiscountApplicationFields
    ...OrderMetafieldsKhakis
  }
`;

const ORDER_LINE_ITEM_FIELDS_SUNLOVE = `#graphql
  fragment OrderLineItemFieldsSunlove on Order {
    lineItems(first: 100) {
      edges {
        node {
          title
          quantity
          currentQuantity
          discountedTotalPrice { ...MoneyFields }
          originalTotalPrice { ...MoneyFields }
          variant {
            ...VariantBaseFields
            product {
              ...ProductCommonFields
              dropDate: metafield(namespace: "operation", key: "drop_date") { ...MetafieldFields }
              launch: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectImageFields }
              }
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference { ...MediaImageFields }
                references(first: 10) { edges { node { ...MediaImageFields } } }
              }
            }
          }
          discountAllocations {
            allocatedAmount { ...MoneyFields }
            discountApplication {
              ...ManualDiscountApplicationFields
              ...AutomaticDiscountApplicationFields
              ...DiscountCodeApplicationFields
            }
          }
        }
      }
    }
  }
`;

const ORDER_METAFIELDS_SUNLOVE = `#graphql
  fragment OrderMetafieldsSunlove on Order {
    drawStatus: metafield(namespace: "custom", key: "draw_status") { ...MetafieldFields }
    featuredImage: metafield(namespace: "operation", key: "featured_image") { ...MetafieldFields }
    isOffline: metafield(namespace: "custom", key: "isoffline") { ...MetafieldFields }
    returnStatus: metafield(namespace: "return", key: "status") { ...MetafieldFields }
    instagram: metafield(namespace: "custom", key: "instagram") { ...MetafieldFields }
    serialNumber: metafield(namespace: "operation", key: "serial_number") { ...MetafieldFields }
    score: metafield(namespace: "operation", key: "score") { ...MetafieldFields }
    productCode: metafield(namespace: "operation", key: "product_code") { ...MetafieldFields }
    cardInfo: metafield(namespace: "custom", key: "card_info") { ...MetafieldFields }
    isfamilysale: metafield(namespace: "operation", key: "isfamilysale") { ...MetafieldFields }
    brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") { ...MetafieldFields }
    release_date: metafield(namespace: "operation", key: "release_date") { ...MetafieldFields }
  }
`;

const CUSTOMER_ORDER_FIELDS_SUNLOVE = `#graphql
  fragment CustomerOrderFieldsSunlove on Order {
    ...OrderBaseFields
    ...OrderLineItemFieldsSunlove
    ...OrderFulfillmentFields
    ...OrderDiscountApplicationFields
    ...OrderMetafieldsSunlove
  }
`;

const ORDER_LINE_ITEM_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment OrderLineItemFieldsWellbeingexpress on Order {
    lineItems(first: 100) {
      edges {
        node {
          title
          quantity
          currentQuantity
          discountedTotalPrice { ...MoneyFields }
          originalTotalPrice { ...MoneyFields }
          variant {
            ...VariantBaseFields
            product {
              ...ProductFieldsWellbeingexpress
              dropDate: metafield(namespace: "operation", key: "drop_date") { ...MetafieldFields }
              launch: metafield(namespace: "custom", key: "launch") {
                ...MetafieldFields
                reference { ...MetaobjectImageFields }
              }
              thumbnailImages: metafield(namespace: "operation", key: "thumbnail_images") {
                ...MetafieldFields
                reference { ...MediaImageFields }
                references(first: 10) { edges { node { ...MediaImageFields } } }
              }
            }
          }
          discountAllocations {
            allocatedAmount { ...MoneyFields }
            discountApplication {
              ...ManualDiscountApplicationFields
              ...AutomaticDiscountApplicationFields
              ...DiscountCodeApplicationFields
            }
          }
        }
      }
    }
  }
`;

const ORDER_METAFIELDS_WELLBEINGEXPRESS = `#graphql
  fragment OrderMetafieldsWellbeingexpress on Order {
    drawStatus: metafield(namespace: "custom", key: "draw_status") { ...MetafieldFields }
    featuredImage: metafield(namespace: "operation", key: "featured_image") { ...MetafieldFields }
    isOffline: metafield(namespace: "custom", key: "isoffline") { ...MetafieldFields }
    returnStatus: metafield(namespace: "return", key: "status") { ...MetafieldFields }
    instagram: metafield(namespace: "custom", key: "instagram") { ...MetafieldFields }
    serialNumber: metafield(namespace: "operation", key: "serial_number") { ...MetafieldFields }
    score: metafield(namespace: "operation", key: "score") { ...MetafieldFields }
    productCode: metafield(namespace: "operation", key: "product_code") { ...MetafieldFields }
    cardInfo: metafield(namespace: "custom", key: "card_info") { ...MetafieldFields }
    isfamilysale: metafield(namespace: "operation", key: "isfamilysale") { ...MetafieldFields }
    brandStoreOrderIds: metafield(namespace: "custom", key: "brand_store_order_id") { ...MetafieldFields }
    release_date: metafield(namespace: "operation", key: "release_date") { ...MetafieldFields }
  }
`;

const CUSTOMER_ORDER_FIELDS_WELLBEINGEXPRESS = `#graphql
  fragment CustomerOrderFieldsWellbeingexpress on Order {
    ...OrderBaseFields
    ...OrderLineItemFieldsWellbeingexpress
    ...OrderFulfillmentFields
    ...OrderDiscountApplicationFields
    ...OrderMetafieldsWellbeingexpress
  }
`;

/** 이 파일의 모든 fragment (registry 등록용) */
/* ------------------------------------------------------------------ *
 * tenui - hydrogen 의 CUSTOMER_QUERY / CHECKOUT_QUERY 가 쓰던 필드만.
 *         주문 메타필드는 custom.return_status 하나뿐이다.
 * ------------------------------------------------------------------ */

const ORDER_LINE_ITEM_FIELDS_TENUI = `#graphql
  fragment OrderLineItemFieldsTenui on Order {
    lineItems(first: 100) {
      edges {
        node {
          title
          quantity
          currentQuantity
          discountedTotalPrice { ...MoneyFields }
          originalTotalPrice { ...MoneyFields }
          variant {
            ...VariantBaseFields
            product {
              ...ProductCommonFields
              cardTag: metafield(namespace: "info", key: "card_tag") { ...MetafieldFields }
            }
          }
          discountAllocations {
            allocatedAmount { ...MoneyFields }
            discountApplication {
              ...ManualDiscountApplicationFields
              ...AutomaticDiscountApplicationFields
              ...DiscountCodeApplicationFields
            }
          }
        }
      }
    }
  }
`;

const ORDER_METAFIELDS_TENUI = `#graphql
  fragment OrderMetafieldsTenui on Order {
    returnStatus: metafield(namespace: "custom", key: "return_status") { ...MetafieldFields }
  }
`;

const CUSTOMER_ORDER_FIELDS_TENUI = `#graphql
  fragment CustomerOrderFieldsTenui on Order {
    ...OrderBaseFields
    ...OrderLineItemFieldsTenui
    ...OrderFulfillmentFields
    ...OrderDiscountApplicationFields
    ...OrderMetafieldsTenui
  }
`;

export const ORDER_FRAGMENTS = [
  ORDER_FULFILLMENT_FIELDS,
  ORDER_DISCOUNT_APPLICATION_FIELDS,
  ORDER_LINE_ITEM_FIELDS_TUNE,
  ORDER_METAFIELDS_TUNE,
  CUSTOMER_ORDER_FIELDS_TUNE,
  ORDER_LINE_ITEM_FIELDS_YESEYESEE,
  ORDER_METAFIELDS_YESEYESEE,
  CUSTOMER_ORDER_FIELDS_YESEYESEE,
  ORDER_LINE_ITEM_FIELDS_THISISNEVERTHAT,
  ORDER_METAFIELDS_THISISNEVERTHAT,
  CUSTOMER_ORDER_FIELDS_THISISNEVERTHAT,
  ORDER_LINE_ITEM_FIELDS_KHAKIS,
  ORDER_METAFIELDS_KHAKIS,
  CUSTOMER_ORDER_FIELDS_KHAKIS,
  ORDER_LINE_ITEM_FIELDS_SUNLOVE,
  ORDER_METAFIELDS_SUNLOVE,
  CUSTOMER_ORDER_FIELDS_SUNLOVE,
  ORDER_LINE_ITEM_FIELDS_WELLBEINGEXPRESS,
  ORDER_METAFIELDS_WELLBEINGEXPRESS,
  CUSTOMER_ORDER_FIELDS_WELLBEINGEXPRESS,
  ORDER_LINE_ITEM_FIELDS_TENUI,
  ORDER_METAFIELDS_TENUI,
  CUSTOMER_ORDER_FIELDS_TENUI,
];
